var money_format = function (t, r) {
  function e(t, r) {
    return void 0 === t ? r : t;
  }
  function a(t, r, a, o) {
    if (
      ((r = e(r, 2)), (a = e(a, ",")), (o = e(o, ".")), isNaN(t) || null == t)
    )
      return 0;
    t = (t / 100).toFixed(r);
    var n = t.split(".");
    return (
      n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) +
      (n[1] ? o + n[1] : "")
    );
  }
  "string" == typeof t && (t = t.replace(".", ""));
  var o = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    i = r || this.money_format;
  switch (i.match(n)[1]) {
    case "amount":
      o = a(t, 2);
      break;
    case "amount_no_decimals":
      o = a(t, 0);
      break;
    case "amount_with_comma_separator":
      o = a(t, 2, ".", ",");
      break;
    case "amount_with_space_separator":
      o = a(t, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      o = a(t, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      o = a(t, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      o = a(t, 0, ".", "");
      break;
    case "amount_with_space_separator":
      o = a(t, 2, ",", "");
      break;
    case "amount_with_apostrophe_separator":
      o = a(t, 2, "'", ".");
  }
  return i.replace(n, o);
};

function load_cart() {
  fetch(window.Shopify.routes.root + "?section_id=cart-drawer")
    .then((response) => response.text())
    .then((responseText) => {
      const cartid = "cart-drawer";
      const html = new DOMParser().parseFromString(responseText, "text/html");
      const destination = document.querySelector(".cart-sidebar");
      const source = html.getElementById(cartid);
      if (source && destination) destination.innerHTML = source.innerHTML;
      document.querySelectorAll(".item-remove").forEach(function (cartRemove) {
        var data_line = cartRemove.dataset.line;
        cartRemove.addEventListener("click", (evt) => removeItem(data_line, 0));
      });

      document.querySelectorAll('.remove-free-gift').forEach(element => {
      element.addEventListener('click', function() {
        setTimeout(()=>{
          document.querySelectorAll('.product-add-cart .size-selector').forEach(selector => {
            selector.classList.remove('hide');
          });
          document.querySelectorAll('.product-add-cart .main-btn').forEach(btn => {
            btn.classList.remove('hide');
          });
          document.querySelectorAll('.add-cart-btn.success').forEach(btn => {
            btn.classList.add('hide');
          });
        },1000);
      });
    });

      document.querySelectorAll(".header-cart").forEach(function (cartButton) {
        cartButton.addEventListener("click", function (e) {
          document.querySelector("body").classList.add("open-drawer");
          document
            .querySelector("body")
            .classList.remove(
              "open-menu",
              "open-search",
              "open-sort",
              "open-filter"
            );
        });
      });

      document
        .querySelectorAll(".overlay-box,.cart-drawer-close")
        .forEach(function (cartButton) {
          cartButton.addEventListener("click", function (e) {
            document
              .querySelector("body")
              .classList.remove(
                "open-drawer",
                "open-menu",
                "open-search",
                "open-sort",
                "open-filter"
              );
          });
          return false;
        });
      const url = "/cart.js";
      fetch(url)
        .then((resp) => resp.json())
        .then(function (data) {
          var cart_count = data.item_count;
          document.querySelector(".cart-count").innerHTML =
            "(" + cart_count + ")";
          document.querySelector(".cart_count_mob").innerHTML = cart_count;
          // if(cart_count>0){
          //   document.querySelector('.cart-count').innerHTML = '(' + cart_count + ')';
          //   document.querySelector('.cart_count_mob').innerHTML = cart_count;
          // }else{
          //   document.querySelector('.cart-count').innerHTML = '';
          //   document.querySelector('.cart_count_mob').innerHTML = '';
          // }

          var productslider = [];
          document.querySelectorAll(".match-with-wrap").forEach(function (Element, index) {
              let productid = Element.dataset.id;
              let outer_carousel = Element.closest(".match-with-wrapouter");
              let nextbutton = outer_carousel.querySelectorAll(".swiper-button-next")[0];
              let prevbutton = outer_carousel.querySelectorAll(".swiper-button-prev")[0];
              let swiperObject = {
                slidesPerView: "auto",
                loop: eval(Element.dataset.loop),
                navigation: {
                  nextEl: nextbutton,
                  prevEl: prevbutton,
                },
                breakpoints: {
                  576: {
                    slidesPerView: Element.dataset.grid,
                  },
                },
              };
              productslider[productid] = new Swiper(Element, swiperObject);
            });
          var h3height = 0;
          $(".match-slider .grid-meta .pro_name").each(function () {
            if (h3height < $(this).outerHeight()) {
              h3height = $(this).outerHeight();
            }
          });
          $(".match-slider .grid-meta .pro_name").height(h3height);
          $(".match-slider .product-images").height("auto");
          // var h_img = 0;
          // $('.match-slider .product-images').each(function() {
          //   if(h_img < $(this).outerHeight()){
          //     h_img = $(this).outerHeight();
          //   };
          // });
          // $('.match-slider .product-images').height(h_img);
          /*---ipgeo_location----*/
              function bulletUspCountry(response) {
              var country_name = response.country_name;
              var allowed_countries_elements = document.querySelectorAll("[data-allow-country]");
              
              if (allowed_countries_elements.length > 0) {
                  allowed_countries_elements.forEach(function(element) {
                      var allowCountryValue = element.getAttribute("data-allow-country");
          
                      // console.log('country_name -->', country_name);
                      // console.log('allowCountryValue -->', allowCountryValue);
          
                      // Check if the country_name is included in the allowCountryValue
                      if (!allowCountryValue.includes(country_name)) {
                          // Hide the <li> element if the country_name is not included
                          element.style.display = "none";
                      } else {
                          // Optionally, show the </li><li> element if the country_name is included
                          element.style.display = "block";
                      }
                  });
              } else {
                  console.log("No elements found with data-allow-country attribute.");
              }
          
              // Handle the opposite case for elements with the attribute free_ship_100_bullet
              var free_ship_100_elements = document.querySelectorAll("[free_ship_100_bullet]");
              
              if (free_ship_100_elements.length > 0) {
                  free_ship_100_elements.forEach(function(element) {
                      var allowCountryValue = element.getAttribute("data-allow-country");
          
                      // console.log('country_name -->', country_name);
                      // console.log('allowCountryValue -->', allowCountryValue);
          
                      // Always hide the element if the country_name is "United States"
                      if (country_name === "United States") {
                          element.style.display = "none";
                      } else if (!allowCountryValue.includes(country_name)) {
                          // Show the </li><li> element if the country_name is not included
                          element.style.display = "block";
                      } else {
                          // Optionally, hide the </li><li> element if the country_name is included
                          element.style.display = "none";
                      }
                  });
              } else {
                  console.log("No elements found with free_ship_100_bullet attribute.");
              }
          
              // Handle the case for elements with the attribute free_ship_bullet
              var free_ship_elements = document.querySelectorAll("[free_ship_bullet]");
              
              if (free_ship_elements.length > 0) {
                  free_ship_elements.forEach(function(element) {
                      // Always hide the element if the country_name is "United States"
                      if (country_name === "United States") {
                          element.style.display = "none";
                      }
                  });
              } else {
                  console.log("No elements found with free_ship_bullet attribute.");
              }
          }
          _ipgeolocation.getGeolocation(
            bulletUspCountry,
            "92040e9724fd4f8aaf75d317b69fb8c6"
          );

          function currentcountry(response) {
            var shop_currency = $("#shop_currency_val").text();
            var country_name = response.country_name;
            var currency_rate = Shopify.currency.rate;
            var new_alllist = "";
            $(".oq_countrylist").each(function (e) {
              var eachcountry = $(this).data("country");
              if (eachcountry.indexOf(country_name) != -1) {
                $(this).addClass("active");
              }
              new_alllist += eachcountry + ",";
            });
            $.ajax({
              type: "GET",
              url: "/cart.js",
              dataType: "json",
              success: function (cart) {
                var cart_total = cart.total_price,
                  ship_text = $(".free_shipping_static_text").attr(
                    "data-freeship"
                  ),
                  no_fees = $(".free_shipping_static_text").attr("data-nofee"),
                  ship_val = $(".free_shipping_static_text").attr("data-ship");
                if (new_alllist.indexOf(country_name) != -1) {
                  var cartfree_cost = parseFloat(
                    $(".oq_countrylist.active").attr("data-cart") *
                      currency_rate
                  );
                  var ship_cost = money_format(
                    parseFloat(
                      $(".oq_countrylist.active").attr("data-ship") *
                        currency_rate
                    ),
                    shop_currency
                  );
                  var ship_days = $(".oq_countrylist.active").attr("data-day");
                  var sub_t = money_format(
                    cart_total +
                      parseFloat(
                        $(".oq_countrylist.active").attr("data-ship") *
                          currency_rate
                      ),
                    shop_currency
                  );
                  if (cart_total > cartfree_cost) {
                    if (cartfree_cost == 0) {
                      $(".days_charge").text(ship_days);
                      $(".no_fees").text(no_fees);
                      $(".shipping_text").text(ship_text);
                    } else {
                      $(".days_charge").text(ship_days);
                      $(".no_fees").text(no_fees);
                      $(".shipping_text").text(ship_text);
                    }
                  } else {
                    $(".days_charge").text(ship_days);
                    $(".no_fees").text(ship_val + " " + ship_cost);
                    $(".shipping_text").text(ship_cost);
                    $(".ship_total").text(sub_t);
                  }
                } else {
                  var ship_days = $(".other_countries").attr("data-day"),
                    cartfree_cost = parseFloat(
                      $(".other_countries").attr("data-cart") * currency_rate
                    ),
                    ship_cost = money_format(
                      parseFloat(
                        $(".other_countries").attr("data-ship") * currency_rate
                      ),
                      shop_currency
                    );
                  var sub_t = money_format(
                    cart_total +
                      parseFloat(
                        $(".other_countries").attr("data-ship") * currency_rate
                      ),
                    shop_currency
                  );
                  if (cart_total > cartfree_cost) {
                    if (cartfree_cost == 0) {
                      $(".days_charge").text(ship_days);
                      $(".no_fees").text(no_fees);
                      $(".shipping_text").text(ship_text);
                    } else {
                      $(".days_charge").text(ship_days);
                      $(".no_fees").text(no_fees);
                      $(".shipping_text").text(ship_text);
                    }
                  } else {
                    var finalprice = cartfree_cost - cart_total;
                    $(".shipping_text").text(ship_cost);
                    $(".days_charge").text(ship_days);
                    $(".no_fees").text(ship_val + " " + ship_cost);
                    $(".ship_total").text(sub_t);
                  }
                }
              },
            });
          }
          _ipgeolocation.getGeolocation(
            currentcountry,
            "92040e9724fd4f8aaf75d317b69fb8c6"
          );
          var f_ht = $(".drawer-footer").innerHeight();
          $(".drawer-middle").css("padding-bottom", f_ht);
          //  var d_top = $('.drawer_footer').offset().top + $(window).height() + 30;
          //  console.log(d_top);
          // $('.cart-sidebar form').scroll(function(){
          //   console.log($(this).scrollTop());
          //    if ($(this).scrollTop() > d_top){
          //      $('.drawer_footer').addClass('fixed_top');
          //    }
          //    else{
          //    $('.drawer_footer').removeClass('fixed_top');
          //    }
          //  });
          var d_top =
            $(".drawer-header").outerHeight() +
            $(".product_cart_dv").outerHeight();
          $(".cart-sidebar form").scroll(function () {
            if ($(this).scrollTop() > d_top) {
              // $('.drawer_footer').addClass('fixed_top');
            } else {
              //$('.drawer_footer').removeClass('fixed_top');
            }
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    });
}
window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    load_cart();
  }
});
load_cart();
function displayLoading() {
  document.querySelector(".cart-sidebar").classList.add("loading-drawer");
}
function hideLoading() {
  document.querySelector(".cart-sidebar").classList.remove("loading-drawer");
}
function removeItem(data_line, qty) {
  const data = { line: data_line, quantity: qty };
  fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      load_cart();
      if(document.location.href.indexOf('/cart') > -1) {
        window.location.href = "/cart";
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          setTimeout(function(e){
            document.querySelector('body').classList.add('open-drawer');
          },500);
        }else{
          window.location.href = "/cart";
        }         
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
$(document).on("click", ".right_btn", function (e) {
  e.preventDefault();
  $(this).closest(".item-row").find(".item-dropdown").slideToggle().closest(".item-row").siblings().find(".item-dropdown").slideUp();
  $(this).toggleClass("active").closest(".item-row").siblings().find(".change-items").removeClass("active");
});
$(document).on("click", ".variant_btn", function (e) {
  e.preventDefault();
  $(this).closest(".cp-variant-btn").find(".item-dropdown").slideToggle().closest(".cp-variant-btn").siblings().find(".item-dropdown").slideUp();
  $(this).toggleClass("active").closest(".cp-variant-btn").siblings().find(".change-items").removeClass("active");
});
$(document).on(
  "click",
  ".item-dropdown li,.cp-variant-dropdown li",
  function (e) {
    e.preventDefault();
    var item_current_id = $(this).data("id");
    var item_current_qty = $(this).data("qty");
    var currentid = $(this).data("current");
    var cartpage_error = $(this).closest(".cp-items-row");
    var cartdrawer_error = $(this).closest(".item-row");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id: item_current_id, quantity: item_current_qty },
      dataType: "json",
      beforeSend: function () {},
      success: function (t) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&id=" + currentid,
          dataType: "json",
          beforeSend: function () {
            displayLoading();
          },
          success: function (e) {
            if (window.location.href.includes("cart")) {
              window.location.href = "/cart";
            } else {
              load_cart();
            }
          },
          error: function (e, t) {
            console.log(e.responseJSON.description);
          },
          complete: function () {
            hideLoading();
          },
        });
      },
      error: function (e, t) {
        console.log(e.responseJSON.description);
        $(cartpage_error)
          .find(".cartpage_error")
          .text(e.responseJSON.description);
        $(cartdrawer_error)
          .find(".cartpage_error")
          .text(e.responseJSON.description);
      },
    });
  }
);
$(document).on("click", ".match-slider .product-addcart", function (e) {
  e.preventDefault();
  var match_id = $(this).data("id");
  var _this = $(this).closest(".match-grid");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { id: match_id, quantity: 1 },
    dataType: "json",
    success: function (t) {
      if (window.location.href.includes("cart")) {
        window.location.href = "/cart";
      } else {
        load_cart();
      }
      $(".cart-sidebar").animate({ scrollTop: 0 }, "slow");
    },
    error: function (e, t) {
      console.log(e.responseJSON.description);
      _this.find(".match-error").text(e.responseJSON.description);
      setTimeout(function () {
        _this.find(".match-error").text("");
      }, 2000);
    },
  });
});
// if ($(window).width() <= 991) {
//   $(document).on("click", ".drwr_ftr_ttl h3", function () {
//     $(this).removeClass("active").siblings().addClass("active");
//     $(this)
//       .parents(".drawer_footer")
//       .find(".cart_sub_total_shipping")
//       .slideToggle();
//     $(".cart-sidebar").toggleClass("active_overlay");
//     $(".cart-sidebar form").animate({ scrollTop: 0 });
//   });
//   $("body").on("click", function (e) {
//     var container = $(".drawer_footer");
//     if (!container.is(e.target) && container.has(e.target).length === 0) {
//       $(".cart-sidebar").removeClass("active_overlay");
//       $(".cart_sub_total_shipping").slideUp();
//     }
//   });
// }

$(document).on("click", ".cd-plus", function (e) {
  e.preventDefault();
  var $qty = $(this).parents(".cd-qty-box").find(".cd-quantity-input");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal)) {
    $qty.val(currentVal + 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest(".cart-item-inr").data("line");
    removeItem(data_line, input_qty);
  }
});
$(document).on("click", ".cd-minus", function (e) {
  e.preventDefault();
  var $qty = $(this).parents(".cd-qty-box").find(".cd-quantity-input");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest(".cart-item-inr").data("line");
    removeItem(data_line, input_qty);
  }
});</li>